export default __webpack_public_path__ + "static/media/mentors.f8127f67.png";